import React, { useState, useEffect } from 'react';
import RevenueWidget from '../components/RevenueWidget';
import PipelineWidget from '../components/PipelineWidget';
import ManualRevenueFeed from '../components/ManualRevenueFeed';
import { fetchDashboardData } from '../api';
import { socket } from '../socket';

export default function Dashboard() {
  const [data, setData] = useState({
    stores: [],
    totalRevenue: 0,
    target: 0,
    pipeline: {},
    manual: [],
  });

  // Fetch dashboard data, used for both initial and live refresh
  const reloadDashboard = () => {
    fetchDashboardData()
      .then(setData)
      .catch((err) => {
        console.error('Dashboard load error:', err);
        // Optionally show an error state here
      });
  };

  useEffect(() => {
    reloadDashboard(); // initial fetch
  }, []);

  useEffect(() => {
    // Setup socket event for real-time updates
    socket.on('dashboard_update', reloadDashboard);
    return () => {
      socket.off('dashboard_update', reloadDashboard);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <RevenueWidget
          stores={data.stores}
          totalRevenue={data.totalRevenue}
          target={data.target}
        />
        <PipelineWidget pipeline={data.pipeline} />
        <ManualRevenueFeed manual={data.manual} />
      </div>
    </div>
  );
}
